export type TNotesCardProps = {
  className?: string;
  width?: string;
  avatarSize?: number;
  createdAt?: string;
  createdOn?: string;
  bookmarkClickHandler?: any;
  data: DataOptions;
  noteEditor?: Boolean;
  setNoteEditState?: any;
  membersChangeHandler?: any;
  setContent?: any;
  deleteHandler?: any;
  setEditNoteData?: any;
  setMembersOptions?: any;
  setEditMode?: any;
  setBookmarkStatus?: any;
  setRecipientType?: any
  setPrevBookmarkStatus?: any
  tab?: string
  onShowMore?: any;
  rightDrawerCloseHandler?: any;
};

export type DataOptions = {
  patientName: string;
  patientId: string;
  notes: string;
  notesId: number;
  careMgrFirstName: string;
  careMgrLastName: string;
  notesCreateDate?: string;
  isBookMarked?: boolean;
  noteType?: string;
  recipientType?: string;
  careManagerId? : string;
  isShowMore?: boolean
  patientStatus?: string;
};

export type TNotesProps = { members?: any; updateMembers?: any; searchValue?: any; filterValue?: any; updateStatus?: any, filterStartDate?: string, filterEndDate?: string, defaultTab?: any, setDefaultTab?: any, rightDrawerCloseHandler?: any };

export const tabs = [
  {
    name: "Bookmarked",
    tabCount: "bookMarkedTotalCount",
    key: "1",
  },
  {
    name: "All Notes",
    tabCount: "allNotesTotalCount",
    key: "2",
  },
];

export const membersOption = ["Ashley John", "Aster Milton", "Bob Dylan", "Bobaz Darwin"];
export const colors = ["blue", "gray", "orange", "red", "green", "purple"];
export const titles = ["My Notes", "Other Notes", "Note to PCP"]
